<template>
  <div class="blog-additional-content">
    <app-section id="models" theme="dark" class="models-section">
      <our-models :models="models" />
    </app-section>
    <app-section theme="light-lilac" class="reviews-section">
      <reviews />
    </app-section>
    <app-section id="videos" theme="nude" :wave-top="true" class="video-categories-section">
      <video-categories :videos="videos" :tags="tags" />
    </app-section>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, onBeforeMount } from "vue";
import { useLandingStore } from "@/store/landing";
import { useI18n } from "vue-i18n";
import OurModels from "@/components/v2/our-models/index.vue";
import AppSection from "@/components/v2/section/index.vue";

const VideoCategories = defineAsyncComponent(() => import("@/components/v2/video-categories/index.vue"));
const Reviews = defineAsyncComponent(() => import("@/components/v2/reviews/index.vue"));

defineOptions({
  name: "blog-additional-content",
});

const landingStore = useLandingStore();
const { locale } = useI18n();

const defaultLanding = computed(() => landingStore.getDefaultLandingPage(locale.value));
const models = computed(() => defaultLanding.value?.models ?? []);
const tags = computed(() => defaultLanding.value?.tags ?? []);
const videos = computed(() => defaultLanding.value?.videos ?? []);

onBeforeMount(async () => {
  if (!defaultLanding.value) {
    await landingStore.fetchLandingPage({ lang: locale.value });
  }
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
